<!-- @format -->

<app-course-unit-info-brochure
  [courseUnit]="courseUnit"
  [sortedByNameResponsibilityInfos]="sortedByNameResponsibilityInfos"
  [language]="language"></app-course-unit-info-brochure>
